import { useReveal } from "@/hooks/useReveal";

const ROWS: [string, string][] = [
  ["Minimum first order", "Half a container as a minimum"],
  ["Default Incoterm", "FOB Cartagena or Buenaventura, Colombia"],
  ["Alternative Incoterm", "CIF Cape Town or Durban, quoted on request"],
  ["Samples", "Quoted on request"],
  [
    "Payment terms, first order",
    "Irrevocable confirmed letter of credit, or substantial advance payment",
  ],
  [
    "Labelling",
    "Adapted to South African labelling requirements, with the importer's details, agreed in writing before the run",
  ],
];

export default function TradeData() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="trade" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            The trade data, all in one place
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Everything you need to build a landed cost and a shelf price before
            you reply to us.
          </p>
        </div>

        <div className="mt-12 bg-white rounded-lg border border-cream-dark/60 overflow-hidden">
          {ROWS.map(([label, value], i) => (
            <div
              key={label}
              className={`grid grid-cols-1 sm:grid-cols-[280px_1fr] gap-2 sm:gap-6 px-6 py-5 ${
                i !== ROWS.length - 1 ? "border-b border-cream-dark/50" : ""
              }`}
            >
              <div className="text-ink/50 text-sm font-semibold uppercase tracking-wider self-start pt-0.5">
                {label}
              </div>
              <div className="text-ink text-[17px] leading-relaxed">{value}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}